module.exports = __webpack_public_path__ + "static/media/banner-bg-man@3x.9df25a7a.png";